import Loading from 'app/components/Loading/LoadingScreen';
import EditorialAccessErrorScreen from 'app/components/EditorialAccessBoundary/EditorialAccessErrorScreen';
import { useEditorialAccess } from 'app/context/editorialAccess.context';
import { useAuthUser } from 'app/hooks/useAuthUser';
import { EDITORIAL_ACCESS_STATUS } from 'app/models/editorialAccess';
import { isPublisher } from 'app/models/user';
import PropTypes from 'prop-types';
import React from 'react';

export default function EditorialAccessBoundary({ children }) {
  const access = useEditorialAccess();
  const { authUser } = useAuthUser();

  if (!authUser?.role_guid) return <Loading />;
  if (!isPublisher(authUser)) return children;
  if (access.status === EDITORIAL_ACCESS_STATUS.error) return <EditorialAccessErrorScreen onRetry={access.retry} />;
  if (access.status !== EDITORIAL_ACCESS_STATUS.ready) return <Loading />;

  return children;
}
EditorialAccessBoundary.propTypes = { children: PropTypes.node };
